import React, { useEffect, useState } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import ReactStars from "react-rating-stars-component";
import BaseSelect from 'components/baseSelect';


const KnowledgeOrSkillsForm = ({errors, touched, handleChange, values, element, removeKnowledgeOrSkillsForm, options, index, lastIndex, empresaId = 96}) => {
    const onRemoveForm = () => removeKnowledgeOrSkillsForm(element.id);
    const [valoracion, setValoracion] = useState(values[`valoracion_${element.id}`])
    const [primerTitulo, setPrimerTitulo] = useState(' ')


    useEffect(() => {
        if (index == 0) {
            setPrimerTitulo('Conocimiento o habilidad *');
        }
    }, []);

    const legend = [
        {
            key: 1,
            value: 'Bajo'
        },
        {
            key: 2,
            value: 'Regular'
        },
        {
            key: 3,
            value: 'Bueno'
        },
        {
            key: 4,
            value: 'Muy bueno'
        },
        {
            key: 5,
            value: 'Excelente'
        }
    ];
    const inlineStyle = {
        display: 'flex',
        flexFlow: 'row'
    }

    const labelStyle = {
        marginTop: 15,
        marginLeft: 10
    }

    return (
        <>

            <BaseSelect
                md={3}
                customMb={ index != lastIndex ? 0 : null}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                values={values}
                label={primerTitulo}
                name={`knowledgeOrSkills_${element.id}`}
                url={'Conocimiento?$filter=EmpresaId eq ' + empresaId} 
                displayName={'descripcion'}
            />
            
            <Form.Group as={Col} md="3" style={{marginBottom: 0}} controlId={"validationAmount_" + element.id}>
                <div style={ primerTitulo == ' ' ? {marginTop: 16} : {marginTop: 23}}>
                    <div style={inlineStyle}>
                        <ReactStars
                            count={5}
                            size={35}
                            name={`valoracion_${element.id}`}
                            value={values[`valoracion_${element.id}`]}
                            onChange={(data) => {
                                values[`valoracion_${element.id}`] = data
                                setValoracion(data)
                            }} 
                            activeColor="#00BBEC"
                        />
                        <div style={labelStyle}>
                            { legend.find(x => x.key == valoracion).value }
                        </div>
                    </div>
                </div>
            </Form.Group>
            
            <Form.Group as={Col} md="6" style={{marginBottom: 0, marginTop: 31}}>
                <Button onClick={onRemoveForm} variant="outline-primary"><i className="fas fa-trash-alt"></i></Button>
            </Form.Group>
        </>
    )
}

export default KnowledgeOrSkillsForm;